import React from 'react';

export default function CreditLimitBasisCard() {
  return (
    <section className="cardSection _textAlign_center _horizontalPadding--xlarge-tabletUp">
      <h3 className="subhead -darkBlue" data-testid='credit-limit-basis-headline'>
        Your limit is based on our understanding of your business
      </h3>

      <p className="label -secondary _marginBottom--small">
        These include factors such as your company type, industry, financial performance, and the transactions with your buyers.
      </p>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/features/account/components/CreditLimitBasisCard.js